import React from 'react';
interface StatsCardProps {
    targetCustomerCount?: number;
    actualCustomerCount?: number;
    targetQty?: number;
    monthWiseCollected?: Record<string, number>;
    img?: string;
    householdpercentage?: number;
    plasticpercentage?: number;
    lastMonthCollected?: number;
}

export default function StatsCard({
    targetCustomerCount = 0,
    actualCustomerCount = 0,
    targetQty = 0,
    monthWiseCollected = {},
    img,
    householdpercentage = 0,
    plasticpercentage = 0,
    lastMonthCollected = 0
}: StatsCardProps) {

    // Get the latest month's collected quantity
    const latestMonthCollected = monthWiseCollected ? Object.values(monthWiseCollected)[0] || 0 : 0;

    // Format large numbers with k suffix
    const formatNumber = (num: number) => {
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'k';
        }
        return num.toString();
    };

    return (
        <div className="bg-white-100 flex gap-8">
            {/* HOUSEHOLD CARD */}
            <div className="flex-1 rounded-3xl overflow-hidden" style={{ backgroundColor: '#f4b7f9' }}>
                {/* Top Section - Main Stats */}
                <div
                    className="px-8 py-6 relative"
                    style={{
                        backgroundColor: '#f4b7f9',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    {/* Icon */}
                    {/* <div className="mb-6 flex justify-start">
                        <img
                            src="/icons8-test-account-60.png"
                            alt="Account"
                            style={{ width: '48px', height: '48px' }}
                        />
                    </div> */}

                    {/* Main Stats - Number and Label on SAME LINE */}
                    <div className="flex items-center gap-4 mb-4 flex-wrap">
                        <span className="text-6xl font-bold text-black leading-none">
                            {formatNumber(targetCustomerCount)}
                        </span>
                        <div className="flex flex-col gap-0">
                            <span className='card-label fw-bold fs-3 mb-1' style={{ color: '#000000' }}>Households</span>
                            {/* <span className="text-base font-semibold text-black">Connected</span> */}
                        </div>
                    </div>

                    <div>
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-sm font-bold text-black">Progress</span>
                            <span className="text-sm font-bold text-black">
                                {householdpercentage.toFixed(1)}%
                            </span>
                        </div>
                        <div style={{
                            height: '16px',
                            backgroundColor: '#ffffff',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            border: '2px solid #000000',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
                        }}>
                            <div style={{
                                height: '100%',
                                width: `${Math.min(householdpercentage, 100)}%`,
                                backgroundColor: '#e795ce',
                                borderRadius: '18px',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                    </div>
                </div>

                {/* Bottom Section - Transparent with Image */}
                <div
                    className="px-8 py-4"
                    style={{
                        backgroundColor: 'rgba(201, 69, 105, 0.3)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundBlendMode: 'multiply'
                    }}
                >
                    <div className="flex flex-col gap-1">
                        <span className="text-5xl font-bold text-black leading-none">
                            {actualCustomerCount}
                        </span>
                        <span className="text-sm font-semibold text-gray-900">Total connected</span>
                    </div>
                </div>
            </div>

            {/* PLASTIC PREVENTED CARD */}
            <div className="flex-1 rounded-3xl overflow-hidden" style={{ backgroundColor: '#4f45f5' }}>
                {/* Top Section - Main Stats */}
                <div
                    className="px-8 py-6 relative"
                    style={{
                        backgroundColor: '#4f45f5',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    {/* Icon */}
                    {/* <div className="mb-6 flex justify-start">
                        <img
                            src="/icons8-weight-kg-50.png"
                            alt="Weight"
                            style={{ width: '48px', height: '48px' }}
                        />
                    </div> */}

                    {/* Main Stats - Number and Label on SAME LINE */}
                    <div className="flex items-center gap-4 mb-4">
                        <span className="text-6xl font-bold text-white leading-none">
                            {(targetQty).toFixed(2)}
                        </span>
                        <div className="flex flex-col gap-0">
                            <span className='card-label fw-bold fs-3 mb-1' style={{ color: 'white' }}>kg</span>
                        </div>
                    </div>

                    <div>
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-sm font-bold text-white">Progress</span>
                            <span className="text-sm font-bold text-white">
                                {plasticpercentage.toFixed(1)}%
                            </span>
                        </div>
                        <div style={{
                            height: '16px',
                            backgroundColor: '#ffffff',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            border: '2px solid #000000',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
                        }}>
                            <div style={{
                                height: '100%',
                                width: `${Math.min(plasticpercentage, 100)}%`,
                                backgroundColor: '#584ddf',
                                borderRadius: '18px',
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                    </div>
                </div>

                {/* Bottom Section - Transparent with Image */}
                <div
                    className="px-8 py-4"
                    style={{
                        backgroundColor: 'rgba(91, 80, 214, 0.7)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    <div className="flex flex-col gap-1">
                        <span className="text-5xl font-bold text-white leading-none">
                            {(lastMonthCollected)?.toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} <span className='card-label fw-bold fs-3 mb-1' style={{ color: 'white' }}>kg</span>
                        </span>
                        <span className="text-sm font-semibold text-gray-100">Total collected</span>
                    </div>
                </div>
            </div>
        </div>
    );
}